export default {
    Backlog: {
        actionItem: '#E2E277',
        background: '#E3E3B0',
        name: 'Backlog',
    },
    Committed: {
        actionItem: '#DEAEEA',
        background: '#EDD8F2',
        name: 'Committed',
    },
    Completed: {
        actionItem: '#8BD399',
        background: '#C3E3C9',
        name: 'Completed',
    },
    'In Progress': {
        actionItem: '#86AEDD',
        background: '#C4D8EF',
        name: 'In Progress',
    },
    'Road Block': {
        actionItem: '#F0C8AB',
        background: '#F0D9C8',
        name: 'Road Block',
    },
};



// WEBPACK FOOTER //
// ./src/utils/ActionStatuses.ts